import { render, staticRenderFns } from "./liveSponsorManagement.vue?vue&type=template&id=8483c5e6&scoped=true"
import script from "./liveSponsorManagement.vue?vue&type=script&lang=js"
export * from "./liveSponsorManagement.vue?vue&type=script&lang=js"
import style0 from "./liveSponsorManagement.vue?vue&type=style&index=0&id=8483c5e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8483c5e6",
  null
  
)

export default component.exports